/* eslint-disable react/prop-types */
import { strCode } from "../../../consts";

import { CellWrapper } from "../../../components/Table/styled";
import { LanguageCell } from "./components/LanguageCell";
import { NameCell } from "./components/NameCell";
import { TranslationCell } from "./components/TranslationFileCell";
import { DefaultQuestionCell } from "./components/DefaultQuestionCell";
import { ControlButtonsCell } from "./components/ControlButtonsCell";

export const LocalisationTabTableColumns = [
  {
    Header: strCode.LANGUAGE_LABEL,
    accessor: "language",
    Cell: ({
      cell,
      callbackFn1: getEditingLocalization,
      callbackFn3: getOriginalDefaultLocalization,
      callbackFn5: getLocalizationToRefetch,
      callbackFn6: setLocalizationToRefetch
    }) => {
      return (
        <CellWrapper width={`240px`}>
          <LanguageCell
            cell={cell}
            getEditingLocalization={getEditingLocalization}
            getOriginalDefaultLocalization={getOriginalDefaultLocalization}
            getLocalizationToRefetch={getLocalizationToRefetch}
            setLocalizationToRefetch={setLocalizationToRefetch}
          />
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.NAME_TITLE,
    accessor: "name",
    Cell: ({ cell, callbackFn1: getEditingLocalization }) => {
      return (
        <CellWrapper width={`200px`}>
          <NameCell cell={cell} getEditingLocalization={getEditingLocalization} />
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.TRANSLATION_FILE,
    accessor: "path",
    Cell: ({ cell, cellWidth5 }) => {
      return (
        <CellWrapper width="100%" maxWidth={`${cellWidth5}px`}>
          <TranslationCell cell={cell} />
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.DEFAULT_QUESTION,
    id: "localization-default-button",
    Cell: ({ cell, callbackFn1: getEditingLocalization }) => {
      return (
        <CellWrapper width={60}>
          <DefaultQuestionCell cell={cell} getEditingLocalization={getEditingLocalization} />
        </CellWrapper>
      );
    }
  },
  {
    id: "localization-control-buttons",
    Cell: ({
      cell,
      callbackFn1: getEditingLocalization,
      callbackFn2: setEditedLocalization,
      callbackFn3: getOriginalDefaultLocalization,
      callbackFn4: setOriginalDefaultLocalization,
      callbackFn6: setLocalizationToRefetch
    }) => {
      return (
        <CellWrapper ml="auto" width={`200px`}>
          <ControlButtonsCell
            cell={cell}
            getEditingLocalization={getEditingLocalization}
            setEditedLocalization={setEditedLocalization}
            getOriginalDefaultLocalization={getOriginalDefaultLocalization}
            setOriginalDefaultLocalization={setOriginalDefaultLocalization}
            setLocalizationToRefetch={setLocalizationToRefetch}
          />
        </CellWrapper>
      );
    }
  }
];
